<template>
  <div class="auth-wrapper auth-v1 px-2">
    <div class="auth-inner py-2">

      <!-- Register v1 -->
      <b-card class="mb-0">
        <b-link class="brand-logo">

        </b-link>
          <b-img :src="member.logo" fluid alt="Fitness Center Logo  健身中心標誌" class="mb-3" v-if="member.logo != null"/>

        <b-card-title class="mb-1">
          Manage Credit Card  管理信用卡
        </b-card-title>
        <b-card-text class="mb-2">

        </b-card-text>

        <!-- form -->
        <validation-observer ref="registerForm">
          <h4 class="brand-text text-primary ml-1" v-if="valid === false">Invalid Link  連結無效</h4>
          <b-form v-if="insert === false && valid === true">
            <b-form-group
              label="Fitness Center Name  健身中心名稱"
              label-for="client_name"
            >
              <b-form-input
                id="client_name"
                v-model="member.client_name"
                trim
                readonly
              />

            </b-form-group>
            <b-form-group
              label="Member Code  會員編號"
              label-for="card"
            >
              <b-form-input
                id="member_code"
                v-model="member.member_code"
                trim
                readonly
              />

            </b-form-group>

            <b-form-group
              label="Mobile  手提電話"
              label-for="mobile"
            >
              <b-form-input
                id="mobile"
                v-model="member.mobile"
                trim
                readonly
              />

            </b-form-group>

            <b-form-group
              v-if="stripe_version === 3"
              label="Credit Card  信用卡"
              label-for="stripe-card-element"
            >
              <div id="stripe-card-element" ref="stripeCardElement" class="form-control stripe-card-element" />
              <small v-if="cardError" class="text-danger">{{ cardError }}</small>
            </b-form-group>

             <b-form-group
               v-else
               label="Credit Card Number  信用卡號碼"
               label-for="card"
             >
               <b-form-input
                 id="card"
                  v-mask="credit_card_format"
                 v-model="card.number"
                 trim
               />

             </b-form-group>

           <b-form-group
             v-if="stripe_version !== 3"
             label="Expiry Date (YYYY-MM)  有效日期（年年年年-月月）"
             label-for="expire"
           >
             <b-form-input
               id="expire"
               v-mask="'####-##'"
               v-model="card.expire"
               trim
             />

           </b-form-group>

          <b-form-group
            v-if="stripe_version !== 3"
            label="CVC  安全碼"
            label-for="cvc"
          >
            <b-form-input
              id="cvc"
              v-mask="cvc_format"
              v-model="card.cvc"
              trim
            />

          </b-form-group>

            <!-- checkbox -->
            <!--<b-form-group>
              <b-form-checkbox
                id="register-privacy-policy"
                v-model="status"
                name="checkbox-1"
              >
                I agree to
                <b-link>privacy policy & terms</b-link>
              </b-form-checkbox>
            </b-form-group>

            <!-- submit button -->
            <b-button
              variant="primary"
              block
              type="button"
              :disabled="submitting || (stripe_version === 3 && !stripeReady)"
              @click="add_card"
            >
              {{ submitting ? 'Submitting 提交中...' : 'Submit 提交' }}
            </b-button>
          </b-form>
        </validation-observer>


<hr  class="mt-4"/>
<div class="text-center" style="font-size: 12px;color:#aaa;font-weight: bold;">
Powered by CloudFit Pro
</div>

      </b-card>
    <!-- /Register v1 -->
    </div>
  </div>

</template>

<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import {
  BCard, BLink, BCardTitle, BCardText, BForm,BImg,
  BButton, BFormInput, BFormGroup, BInputGroup, BInputGroupAppend, BFormCheckbox,
} from 'bootstrap-vue'
import router from '@/router'
import VuexyLogo from '@core/layouts/components/Logo.vue'
import { required, email } from '@validations'
import { togglePasswordVisibility } from '@core/mixins/ui/forms'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

const STRIPE_SCRIPT_ID = 'stripe-js'

export default {
  components: {
    VuexyLogo,
    // BSV
    BCard,
    BLink,
    BCardTitle,
    router,
    BCardText,
    BForm,
    BImg,
    BButton,
    BFormInput,
    BFormGroup,
    BInputGroup,
    BInputGroupAppend,
    BFormCheckbox,
    // validations
    ValidationProvider,
    ValidationObserver,
  },
  mixins: [togglePasswordVisibility],
  data() {
    return {
      stripe_version : 3,
      regEmail: '',
      username: '',
      valid : true,
      stripe_publishable_key : '',
      password: '',
      status: '',
      insert: false,
      stripe: null,
      stripeCard: null,
      stripeReady: false,
      submitting: false,
      cardError: '',
      customerId: null,
      credit_card_format: '#### #### #### ####',
      cvc_format:'###',
      member : {
        member_code: null,
        mobile: null
      },
      card: {
        number : null,
        expire : null,
        cvc: null,
        center_id:  router.currentRoute.params.center_id
      },
      // validation rules
      required,
      email,
    }
  },
  computed: {
    passwordToggleIcon() {
      return this.passwordFieldType === 'password' ? 'EyeIcon' : 'EyeOffIcon'
    },
  },
  watch: {
    "card.number": {
      handler(newValue, oldValue) {
        switch (newValue.substring(0,1)) {
          case "3":
            this.credit_card_format = '#### ###### #####'
            this.cvc_format = '####'
            break;
          default:
          this.credit_card_format = '#### #### #### ####'
            this.cvc_format = '###'
        }
      }
    },
  },
  created() {
    this.get_member()
  },
  beforeDestroy() {
    if (this.stripeCard) this.stripeCard.destroy()
  },
  methods: {
    
    loadStripeSdk() {
      if (typeof window.Stripe === 'function') return Promise.resolve()

      return new Promise((resolve, reject) => {
        const existingScript = document.getElementById(STRIPE_SCRIPT_ID)
        if (existingScript) {
          existingScript.remove()
        }

        const script = document.createElement('script')
        script.id = STRIPE_SCRIPT_ID
        script.src = 'https://js.stripe.com/v3/'
        script.async = true
        script.onload = () => {
          if (typeof window.Stripe === 'function') {
            resolve()
          } else {
            reject(new Error('Stripe.js loaded but the Stripe service is unavailable.'))
          }
        }
        script.onerror = () => reject(new Error('The browser blocked Stripe.js.'))
        document.head.appendChild(script)
      })
    },
    async initializeStripe() {
      const publishableKey = this.stripe_publishable_key
      if (!publishableKey) {
        this.cardError = 'Stripe publishable key is not configured.'
        return
      }
      const isLocalhost = ['localhost', '127.0.0.1', '0.0.0.0'].includes(window.location.hostname)
      if (publishableKey.indexOf('pk_live_') === 0 && window.location.protocol !== 'https:' && !isLocalhost) {
        this.cardError = 'Stripe live mode requires this page to use HTTPS. '
        return
      }

      let initializationStage = 'loading Stripe.js '
      try {
        await this.loadStripeSdk()
        initializationStage = 'creating the Stripe client'
        this.stripe = window.Stripe(publishableKey)
        initializationStage = 'creating the Card Element'
        this.stripeCard = this.stripe.elements().create('card', {
          style: {
            base: {
              color: '#6e6b7b',
              fontFamily: 'Montserrat, Helvetica, Arial, serif',
              fontSize: '14px',
              '::placeholder': { color: '#b9b9c3' },
            },
            invalid: { color: '#ea5455' },
          },
        })
        initializationStage = 'mounting the Card Element'
        await this.$nextTick()
        if (!this.$refs.stripeCardElement) {
          throw new Error('Card Element container is not available.')
        }
        this.stripeCard.mount(this.$refs.stripeCardElement)
        this.stripeCard.on('change', event => {
          this.cardError = event.error ? event.error.message : ''
        })
        this.stripeReady = true
      } catch (error) {
        this.stripeReady = false
        const errorMessage = error && error.message ? error.message : String(error)
        this.cardError = 'Stripe failed while / Stripe 發生錯誤：'+initializationStage+': '+errorMessage
        console.error('Stripe initialization failed:', error)
      }
    },
    async get_member() {
      this.$http.get(process.env.VUE_APP_API_BASE+`/member/token/`+ router.currentRoute.params.token + `/?center=` + router.currentRoute.params.center_id)
        .then(async res => {
          if (res.data.result === false ) {
            this.valid = false
          } else {
            this.member = res.data
            this.stripe_publishable_key = res.data.publishable_key
            if (this.stripe_version === 3) {
              await this.$nextTick()
              await this.initializeStripe()
            }
          }
        })
    },
    async add_card() {
      if (this.submitting) return

      this.submitting = true
      this.cardError = ''
      try {
        if (!this.stripe || !this.stripeCard) {
          throw new Error('Stripe is not ready. Please try again. / Stripe 尚未準備好，請再試一次。')
        }

        const { paymentMethod, error } = await this.stripe.createPaymentMethod({
          type: 'card',
          card: this.stripeCard,
        })
        if (error) {
          throw error
        }

        const publishableKey = this.stripe_publishable_key
        const stripePayload = {
          payment_method_id: paymentMethod.id,
          center_id: this.card.center_id,
          mode: publishableKey.indexOf('pk_test_') === 0 ? 'test' : 'production',
        }

        const customerResponse = await this.$http.post(
          process.env.VUE_APP_API_BASE+'/member/token/'+router.currentRoute.params.token+'/credit_card_v2/customer/',
          stripePayload,
        )
        if (customerResponse.data.result !== true) {
          throw new Error(customerResponse.data.message || 'Unable to create the Stripe customer. / 未能建立 Stripe 客戶資料。')
        }

        this.customerId = customerResponse.data.customer_id
        const paymentMethodId = customerResponse.data.payment_method_id
        // await this.$swal({
        //   title: 'Stripe Created',
        //   html: 'Customer ID: <strong>'+this.customerId+'</strong><br>Payment Method: <strong>'+paymentMethodId+'</strong>',
        //   icon: 'success',
        //   confirmButtonText: 'Continue',
        //   buttonsStyling: false,
        //   customClass: {
        //     confirmButton: 'btn btn-primary',
        //   },
        // })

        const addResponse = await this.$http.post(
          process.env.VUE_APP_API_BASE+'/member/token/'+router.currentRoute.params.token+'/credit_card_v2/add/',
          {
            ...stripePayload,
            customer_id: this.customerId,
            payment_method_id: paymentMethodId,
          },
        )
        if (addResponse.data.result !== true) {
          throw new Error(addResponse.data.message || 'Unable to save the card. / 未能儲存信用卡。')
        }

        this.insert = true
        await this.$swal({
          title: 'Success! / 成功！',
          text: 'The credit card was saved successfully. / 信用卡已成功儲存。',
          icon: 'success',
          showConfirmButton: false,
          buttonsStyling: false,
          backdrop: false,
        })
      } catch (error) {
        this.cardError = error.response && error.response.data && error.response.data.message
          ? error.response.data.message
          : error.message || 'Unable to save the card. Please try again. / 未能儲存信用卡，請再試一次。'
        this.$toast({
          component: ToastificationContent,
          position: 'top-center',
          props: {
            title: 'Error / 錯誤',
            icon: 'XIcon',
            variant: 'danger',
            text: this.cardError,
          },
        })
      } finally {
        this.submitting = false
      }
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/pages/page-auth.scss';

.stripe-card-element {
  height: auto;
  min-height: 38px;
  padding-top: 10px;
}
</style>
